module.exports = __webpack_public_path__ + "img/term.337fea8a.png";